// extracted by mini-css-extract-plugin
module.exports = {"title":"Podcast_title__xYG8z","excerpt":"Podcast_excerpt__a3MLP","content":"Podcast_content__E_ep6","metabar":"Podcast_metabar__N7D1c"};